export class SquirrelEnvironmentDto {
    id!:string;
    name!:string;
    url!:string;
    apiUrl!:string;
    numberOfMigrations!:string;
    migratedWhen!:string;
}